import LegalLayout, { Section } from "../LegalLayout";
import { BUSINESS } from "../businessInfo";

export default function TermsPage() {
  return (
    <LegalLayout
      title="Terms & Conditions"
      intro={
        <p>
          These Terms &amp; Conditions ("Terms") govern your use of {BUSINESS.brandName} (the
          "Platform"), operated by {BUSINESS.legalName} ("we", "us", "our"). By creating an account
          or using the Platform you agree to these Terms. If you do not agree, please do not use the
          Platform.
        </p>
      }
    >
      <Section heading="1. The service">
        <p>
          {BUSINESS.brandName} is a restaurant point-of-sale and ordering platform that provides QR
          self-ordering, a kitchen display system, a captain app, billing, and related management
          tools to restaurants and hospitality businesses ("Merchants") on a subscription basis.
        </p>
        <p>
          Where guests place food orders through a Merchant's QR menu, {BUSINESS.brandName} acts only
          as a technology facilitator between the guest and the Merchant. The Merchant is solely
          responsible for the food, its preparation, pricing, taxes, fulfilment, and quality.
        </p>
      </Section>

      <Section heading="2. Accounts & eligibility">
        <p>
          You must provide accurate, current information when registering and keep your credentials
          secure. You are responsible for all activity under your account. You must be at least 18
          years old and authorised to bind your business to these Terms.
        </p>
      </Section>

      <Section heading="3. Subscriptions, plans & payments">
        <p>
          Paid plans are billed in advance for the period shown at checkout. Prices are listed on our
          {" "}<a className="text-primary-600 hover:text-primary-700" href="/pricing">Pricing</a>{" "}
          page and are exclusive of applicable taxes unless stated otherwise. Online payments are
          processed by our payment partner (Razorpay); we do not store your full card details.
        </p>
        <p>
          We may change plan features or prices on a prospective basis; changes will not affect the
          period you have already paid for. Refunds and cancellations are governed by our{" "}
          <a className="text-primary-600 hover:text-primary-700" href="/refund-policy">
            Refund &amp; Cancellation Policy
          </a>.
        </p>
      </Section>

      <Section heading="4. Acceptable use">
        <p>
          You agree not to misuse the Platform, including: attempting to breach security or access
          another tenant's data, reverse-engineering the service, uploading unlawful or infringing
          content, or using the Platform to send unsolicited messages. We may suspend accounts that
          violate these Terms or applicable law.
        </p>
      </Section>

      <Section heading="5. Merchant responsibilities">
        <p>
          Merchants are responsible for the accuracy of their menus, prices, taxes (including GST),
          invoices, and for compliance with food-safety, licensing, and consumer-protection laws.
          {" "}{BUSINESS.brandName} is not a party to the contract between a Merchant and its guests.
        </p>
      </Section>

      <Section heading="6. Intellectual property">
        <p>
          The Platform, including its software, design, and trademarks, is owned by {BUSINESS.legalName}
          {" "}and protected by law. We grant you a limited, non-exclusive, non-transferable licence to
          use the Platform for your business during your subscription.
        </p>
      </Section>

      <Section heading="7. Limitation of liability">
        <p>
          The Platform is provided "as is". To the maximum extent permitted by law, we are not liable
          for indirect or consequential losses, or for losses arising from Merchant–guest
          transactions, third-party services, or events beyond our reasonable control. Our total
          liability for any claim is limited to the subscription fees you paid in the three months
          before the claim.
        </p>
      </Section>

      <Section heading="8. Termination">
        <p>
          You may stop using the Platform at any time. We may suspend or terminate access for breach
          of these Terms or non-payment. On termination, your right to use the Platform ends; certain
          data may be retained or deleted as described in our{" "}
          <a className="text-primary-600 hover:text-primary-700" href="/privacy-policy">Privacy Policy</a>.
        </p>
      </Section>

      <Section heading="9. Governing law">
        <p>
          These Terms are governed by the laws of India. Disputes are subject to the exclusive
          jurisdiction of the courts at {BUSINESS.jurisdiction}.
        </p>
      </Section>

      <Section heading="10. Contact">
        <p>
          Questions about these Terms? Email{" "}
          <a className="text-primary-600 hover:text-primary-700" href={`mailto:${BUSINESS.supportEmail}`}>
            {BUSINESS.supportEmail}
          </a>{" "}or see our{" "}
          <a className="text-primary-600 hover:text-primary-700" href="/contact">Contact</a> page.
        </p>
      </Section>
    </LegalLayout>
  );
}
